import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RecallPaymentReason} from "../recall-payment-reason.i";

@Injectable()
export class RecallPaymentReasonService {

    constructor(private http: HttpClient) {
    }

    public getRecallPaymentReason(): Observable<Array<RecallPaymentReason>> {
        return this.http.get<Array<RecallPaymentReason>>(`api/client/dictionary/recall_payment/reason`);
    }

    public canRecall(id: number): Observable<RecallPaymentReason> {
        return this.http.get<RecallPaymentReason>(`/api/backoffice/transfers/${id}/can_recall`);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/recall-payment-reason.service.ts